/*
 * From https://github.com/juliendecharentenay/extra-vue-ui/blob/main/composable/error.js
 */
import { ref } from "vue";

export function useComponentError(context) {
  const on_error = ({msg, e}) => {
    console.error(e);
    context.emit('error', {msg, e});
  };
  const catcher = (key, f, d = null) => {
    try {
      return f();
    } catch (e) {
      on_error({msg: `Error in ${key}`, e});
    }
    return d;
  };
  return { on_error, catcher };
}

export function useError() {
  const error = ref(null);

  const on_error = ({msg, e}) => {
    console.error(e);
    if (error.value === null) { error.value = {msg, e}; }
  };
  const catcher = (key, f, d = null) => {
    try {
      return f();
    } catch (e) {
      on_error({msg: `Error in ${key}`, e});
    }
    return d;
  };
  return { error, on_error, catcher };
}
